interface IProductAvailability {
  offer?: {
    onOrder?: boolean;
    isAvailable?: boolean;
  };
  onOrder?: boolean;
  isAvailable?: boolean;
}

export const isProductAvailable = <T extends IProductAvailability>(product: T): boolean => {
  if (product?.offer) {
    return !!product.offer.isAvailable;
  }

  return !!product?.isAvailable;
};

export const isProductOnOrder = <T extends IProductAvailability>(product?: T): boolean => {
  if (product?.offer) {
    return !!product.offer.onOrder;
  }

  return !!product?.onOrder;
};
